<template lang="pug">
.form-row
  input.form-control.searchbar(
    v-model="searchExpression" type="text"
    v-on:keyup.enter="search"
  )
  span(@click="search")
    template(v-if="resultVisible")
      | {{ currentOccurrence }}/{{ searchOccurrences }}
    i.fas.fa-search.ml-1
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import highlight_mixin from 'common/mixins/highlight'

export default {
  name: 'documents-search-bar-vue',
  mixins: [highlight_mixin],
  props: {
    searchTokens: { type: Array, default: () => [] }
  },
  data() {
    return {
      searchExpression: this.searchTokens.join(' '),
      resultVisible: false
    }
  },
  computed: {
    ...mapState('document', [
      'searching'
    ]),
  },
  methods: {
    search() {
      if (this.searchExpression) {
        this.initSearch()
        this.resetOccurrences()
        this.setSearchTokens([this.searchExpression])
      }
    },
    ...mapMutations('search', [
      'setSearchTokens'
    ]),
    ...mapMutations('document', [
      'initSearch'
    ])
  },
  created() {
    var self = this
    window.addEventListener('load', () => {
      self.search()
    })
  },
  watch: {
    searching(value) {
      if (!value) {
        this.calculateOccurrences()
        this.resultVisible = true
        this.goFirstHightlight()
      }
    }
  }
}
</script>
